import { authApi, userApi } from "apiClient/v2";
import { authStorage } from "constants/storage";
import { User } from "interfaces/models/user";
import store from "redux/store";
import { setToken } from "redux/userSlice";
import { logDev, logError } from "./logs";
import { getLocalStorage } from "./storage";
import { getLocalStorageUser, logout, storageUser } from "./user";
import { CACHE_QUERY_PARAM } from "constants/serviceWorker";
import { addParamToUrl } from "./fetch";
import networkMonitor from "libs/network-monitor/NetworkMonitor";
import { setAuthStatus } from "redux/appSlice";
import { AuthStatus } from "redux/appSlice";

export const EXPIRE_TIME_TOKEN = 5 * 60 * 1000;

export const getCurrentUser = async (
  callback: (error: any, data: any) => void
) => {
  const user: User = getLocalStorage("userInfo");

  if (!user?.id) {
    return callback(null, null);
  }

  try {
    const req = await userApi.handleGetProfile();

    return callback(null, req);
  } catch (err) {
    return callback(err, null);
  }
};

export const getCurrentUserAndIdToken = () => {
  const user = getLocalStorageUser();
  const token = authStorage.token;

  return { user, token };
};

export const fetchAndStoreUser = async (shouldCache = false) => {
  let userUrl = `${process.env.REACT_APP_API_HOST_URL}/v1/auth/current-user`;
  if (shouldCache) {
    userUrl = addParamToUrl(userUrl, CACHE_QUERY_PARAM, "true");
  }
  const userData = await (
    await fetch(userUrl, {
      credentials: "include",
    })
  ).json();
  const user = userData?.data?.user;
  const tokens = userData?.data?.tokens;

  if (!user || !tokens) throw new Error("Refresh token failed");

  authStorage.token = tokens.idToken;
  storageUser(user);
  store.dispatch(setToken(tokens.idToken));

  return user;
};

export const doRefreshToken = async (shouldCache = false) => {
  try {
    const isOnline = networkMonitor.isOnline();
    if (isOnline) {
      const response = await authApi.refreshTokenFromPlanet(shouldCache);
      if (!response) throw new Error("Refresh token failed");
    }

    return fetchAndStoreUser(shouldCache);
  } catch (err) {
    logError(err);
    logout();
  }
};

export const login = async () => {
  if (store.getState().app.authStatus !== AuthStatus.REFRESHING) {
    store.dispatch(setAuthStatus(AuthStatus.REFRESHING));
  }

  try {
    const result = await doRefreshToken();
    if (result) {
      const { token } = getCurrentUserAndIdToken();
      store.dispatch(setToken(token));
      store.dispatch(setAuthStatus(AuthStatus.LOGGED));

      return true;
    }
  } catch (err) {
    logDev(err);
    /** Ignore */
  }

  store.dispatch(setAuthStatus(AuthStatus.LOGOUT));

  return false;
};

export const decodeJwt = (token: string) => {
  const jwtParts = token.split(".");
  const jwtPayload = jwtParts[1];
  const decodedPayload = window.atob(jwtPayload);
  const jsonPayload = JSON.parse(decodedPayload);

  return jsonPayload;
};
